<div class="search-container">
  <input
    type="text"
    [ngClass]="{ 'search-input': true, opened: shouldShowOptions }"
    placeholder="Search Participants"
    [(ngModel)]="searchValue"
    (ngModelChange)="filterParticipants()"
  />
  <svg class="input-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.33333 7.33333H7.80667L7.62 7.15333C8.27333 6.39333 8.66667 5.40667 8.66667 4.33333C8.66667 1.94 6.72667 0 4.33333 0C1.94 0 0 1.94 0 4.33333C0 6.72667 1.94 8.66667 4.33333 8.66667C5.40667 8.66667 6.39333 8.27333 7.15333 7.62L7.33333 7.80667V8.33333L10.6667 11.66L11.66 10.6667L8.33333 7.33333ZM4.33333 7.33333C2.67333 7.33333 1.33333 5.99333 1.33333 4.33333C1.33333 2.67333 2.67333 1.33333 4.33333 1.33333C5.99333 1.33333 7.33333 2.67333 7.33333 4.33333C7.33333 5.99333 5.99333 7.33333 4.33333 7.33333Z"
      fill="#333333"
    />
  </svg>
  @if (shouldShowOptions) {
    <div class="search-options-container">
      @for (user of filteredParticipants; track user) {
        <div (click)="sendMessageTo(user.userId ?? '')" class="option-container flex justify-between items-center">
          <span>{{ user | formatUserName }}</span>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.334 0.333496H1.66732C0.933984 0.333496 0.333984 0.933496 0.333984 1.66683V13.6668L3.00065 11.0002H12.334C13.0673 11.0002 13.6673 10.4002 13.6673 9.66683V1.66683C13.6673 0.933496 13.0673 0.333496 12.334 0.333496ZM5.00065 6.3335H3.66732V5.00016H5.00065V6.3335ZM7.66732 6.3335H6.33398V5.00016H7.66732V6.3335ZM10.334 6.3335H9.00065V5.00016H10.334V6.3335Z"
              fill="#333333"
            />
          </svg>
        </div>
      }
      @if (filteredParticipants.length === 0) {
        <div class="option-container flex justify-center items-center">No results found</div>
      }
    </div>
  }
</div>
